



const DIAOracleV2 = require("./artifacts/contracts/DIAOracleV2.sol/DIAOracleV2.json");

module.exports = DIAOracleV2;
